import { useQuery, useSubscription } from "@apollo/client";
import gql from "graphql-tag";
import { MY_HR_GET_CHANGE_REQUESTS_BADGES } from "my-hr/graphql";

export const MY_HR_CHANGE_REQUESTS_SUBSCRIPTION = gql`
  subscription changeRequestsSubscription {
    changeRequestsSubscription
  }
`;

export const useMyHrChangeRequestsBadges = (contract: string) => {
  const { data, loading, error, refetch } = useQuery(
    MY_HR_GET_CHANGE_REQUESTS_BADGES,
    {
      fetchPolicy: "cache-and-network",
      variables: { contract },
    },
  );

  const result = data?.changeRequestsBadges || 0;

  useSubscription(MY_HR_CHANGE_REQUESTS_SUBSCRIPTION, {
    onData: () => {
      refetch();
    },
  });

  return {
    data: result,
    loading,
    error,
  };
};

export default useMyHrChangeRequestsBadges;
